import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PromoBar from "./components/PromoBar";
import WelcomePopup from "./components/WelcomePopup";
import GrandOpeningBanner from "./components/GrandOpeningBanner";
import StaffPreviewBanner from "./components/StaffPreviewBanner";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyOrders from "./pages/MyOrders";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminDashboard from "./pages/admin/AdminDashboard";
import OrdersDisplay from "./pages/admin/OrdersDisplay";
import DriverPortal from "./pages/driver/DriverPortal";

function Layout({ children }) {
  const loc = useLocation();
  const hide = loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/driver");
  return (
    <>
      {!hide && <StaffPreviewBanner />}
      {!hide && <GrandOpeningBanner />}
      {!hide && <Navbar />}
      <main className="min-h-[60vh]">{children}</main>
      {!hide && <Footer />}
      {!hide && <PromoBar />}
      {!hide && <WelcomePopup />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<ProtectedRoute roles={["customer"]}><Checkout /></ProtectedRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/my-orders" element={<ProtectedRoute roles={["customer"]}><MyOrders /></ProtectedRoute>} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin/orders-display" element={<ProtectedRoute roles={["admin", "manager", "cashier"]}><OrdersDisplay /></ProtectedRoute>} />
                <Route path="/admin/*" element={<ProtectedRoute roles={["admin", "manager", "cashier"]}><AdminDashboard /></ProtectedRoute>} />
                <Route path="/driver/*" element={<ProtectedRoute roles={["driver"]}><DriverPortal /></ProtectedRoute>} />
              </Routes>
            </Layout>
            <Toaster richColors position="top-center" />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
